module.exports = __webpack_public_path__ + "static/img/type4.194f77a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/type4.png
// module id = EBXI
// module chunks = 1